<ng-container [formGroup]="addressForm">
  <vnm-form-field label="address-form.address-1" class="p-field-full-width">
    <input
      type="text"
      pInputText
      formControlName="address1"
      class="p-field p-field-full-width"
      autocomplete="address address-line-1"
    />
  </vnm-form-field>
  <vnm-form-field label="address-form.address-2" class="p-field-full-width">
    <input
      type="text"
      pInputText
      formControlName="address2"
      class="p-field p-field-full-width"
      autocomplete="address address-line-2"
    />
  </vnm-form-field>
  <div class="p-grid-fit">
    <vnm-form-field label="address-form.city">
      <input
        type="text"
        pInputText
        formControlName="city"
        class="p-field p-field-full-width"
        autocomplete="address city"
      />
    </vnm-form-field>
    <vnm-form-field label="address-form.postal-code">
      <input
        type="text"
        pInputText
        formControlName="postalCode"
        class="p-field p-field-full-width"
        autocomplete="address postal-code"
      />
    </vnm-form-field>
    <input type="hidden" formControlName="country" />
    <input type="hidden" formControlName="province" />
  </div>
  <div class="p-grid-fit">
    <vnm-form-field label="address-form.country">
      <p-dropdown
        #countrySelect
        [options]="countries"
        name="countrySelect"
        optionLabel="name"
        autocomplete="address country"
        appendTo="body"
        styleClass="p-field-full-width"
        (onChange)="onCountryChange($event)"
        [placeholder]="'address-form.country' | translate"
        [(ngModel)]="selectedCountry"
        [ngModelOptions]="{ standalone: true }"
      ></p-dropdown>
    </vnm-form-field>
    <vnm-form-field label="address-form.province">
      <p-dropdown
        #provinceSelect
        [options]="countrySelect?.value?.provinces"
        optionLabel="name"
        name="provinceSelect"
        autocomplete="address province"
        appendTo="body"
        styleClass="p-field-full-width"
        (onChange)="onProvinceChange($event)"
        [placeholder]="'address-form.province' | translate"
        [(ngModel)]="selectedProvince"
        [ngModelOptions]="{ standalone: true }"
      ></p-dropdown>
    </vnm-form-field>
  </div>
</ng-container>
